import { render, staticRenderFns } from "./HeartRate.vue?vue&type=template&id=025f4856&scoped=true"
import script from "./HeartRate.vue?vue&type=script&lang=js"
export * from "./HeartRate.vue?vue&type=script&lang=js"
import style0 from "./HeartRate.vue?vue&type=style&index=0&id=025f4856&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f4856",
  null
  
)

export default component.exports